import { set } from "./vuex";

export default {
  updateTokenId: set("tokenId"),
  updateTokenInfo: set("tokenInfo"),
  updateQueryAnswer: set("queryAnswer"),
  updateReloadPage: set("reloadPage"),
  updateShowError: set("showError"),
  updateErrorMsg: set("errorMsg"),
  updateTheme: set("theme"),
  updateCurBlockHeight: set("curBlockHeight"),
  updateToLoadMore: set("toLoadMore"),
  updateHasMore: set("hasMore"),
  updateLoadingData: set("loadingData")
};
